import { SHOW_CONFIRMATION } from '~~/constants/queryOptions';
import { StringBoolean } from '~~/types/StringBoolean';

export const useConfirmationPopup = () => {

  const route = useRoute();
  const router = useRouter();

  const isConfirmationPopupOpen = useState('isConfirmationPopupOpen', () => false);
  const caseNumber = useState<string | null>('confirmationPopupCaseNumber', () => null);
  const error = useState<boolean>('confirmationPopupError', () => false);

  const clearPopupState = () => {

    caseNumber.value = null;
    error.value = false;
  
  };

  const removeConfirmationFlagFromQuery = () => {

    const currentQuery = { ...route.query };
    Reflect.deleteProperty(currentQuery, SHOW_CONFIRMATION);
    router.replace({
      query: currentQuery,
    });
  
  };

  const openConfirmationPopup = ({ caseId, hasError }: { caseId?: string, hasError?: boolean } = {}) => {

    clearPopupState();
    isConfirmationPopupOpen.value = true;

    if (caseId) {

      caseNumber.value = caseId;
    
    }

    if (hasError) {

      error.value = true;
    
    }
  
  };
  const closeConfirmationPopup = () => {

    clearPopupState();
    isConfirmationPopupOpen.value = false;
  
  };

  const checkIfShouldShowConfirmationPopup = () => {

    if (route?.query?.[SHOW_CONFIRMATION] !== StringBoolean.true) {

      return;
    
    }
    removeConfirmationFlagFromQuery();
    openConfirmationPopup();
  
  };

  return {
    checkIfShouldShowConfirmationPopup,
    isConfirmationPopupOpen,
    caseNumber,
    error,
    openConfirmationPopup,
    closeConfirmationPopup,
  };

};
